import {Row} from '../../types'
import {getUsersList} from './get-users-list'

export const getUnregisteredUsers = (tableData: unknown[]): string[] => {
  const unregisteredUsers: string[] = []
  const users = getUsersList()
  tableData.forEach((row: Row) => {
    if (row.Assigned && !users.includes(row.Assigned)) {
      unregisteredUsers.push(row.Assigned)
    }
  })
  return unregisteredUsers
}
